import { Pagination as AntPagination, Button } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useResponsive } from '@/shared';
import styles from './Pagination.module.css';
import { usePagination } from './usePagination';
import type { PaginationProps } from './types';

export const Pagination = ({
  total,
  showSizeChanger = false,
  pageSizeOptions = [10, 20, 50, 100],
  className,
  disabled = false,
}: PaginationProps) => {
  const { page, limit, handleChange } = usePagination();
  const { isMobile } = useResponsive();

  const totalPages = Math.ceil(total / limit);

  if (totalPages <= 1 || total === 0) {
    return null;
  }

  const itemRender = (
    _page: number,
    type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next',
    originalElement: React.ReactNode
  ) => {
    if (type === 'prev') {
      return (
        <Button type='default' icon={<ArrowLeftOutlined />} disabled={page === 1} className={styles.button}></Button>
      );
    }
    if (type === 'next') {
      return (
        <Button type='default' className={styles.button} disabled={page === totalPages}>
          <ArrowRightOutlined />
        </Button>
      );
    }
    if (type === 'jump-prev' || type === 'jump-next') {
      return <span className={styles.ellipsis}>...</span>;
    }
    return originalElement;
  };

  return (
    <div className={`${styles.paginationWrapper} ${className ?? ''}`}>
      <AntPagination
        current={page}
        total={total}
        pageSize={limit}
        onChange={handleChange}
        showSizeChanger={showSizeChanger}
        pageSizeOptions={pageSizeOptions}
        itemRender={itemRender}
        disabled={disabled}
        className={styles.pagination}
        showQuickJumper={false}
        showLessItems={isMobile}
      />
    </div>
  );
};
